module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "header header-relative"
  }, [_c('div', {
    staticClass: "flex justify-center align-center sheight"
  }, [_c('div', {
    staticClass: "pointer",
    staticStyle: {
      "width": "150px"
    },
    on: {
      "click": _vm.tohome
    }
  }, [_c('el-image', {
    staticStyle: {
      "width": "80px",
      "height": "80px"
    },
    attrs: {
      "src": "/static/assets/images/logo1.png",
      "fit": "fill"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "swidth"
  }, [_c('el-input', {
    staticClass: "input-with-select",
    attrs: {
      "placeholder": "请输入内容"
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.tosearch.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.keyword),
      callback: function($$v) {
        _vm.keyword = $$v
      },
      expression: "keyword"
    }
  }, [_c('el-select', {
    attrs: {
      "slot": "prepend",
      "placeholder": "信息服务"
    },
    on: {
      "change": _vm.tabselect
    },
    slot: "prepend",
    model: {
      value: (_vm.selectid),
      callback: function($$v) {
        _vm.selectid = $$v
      },
      expression: "selectid"
    }
  }, _vm._l((_vm.selectlist), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.title,
        "value": item.value
      }
    })
  }), 1), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "background-color": "#fff"
    },
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.tosearch
    },
    slot: "append"
  }, [_vm._v("\n                        搜索\n                    ")])], 1)], 1), _vm._v(" "), (!_vm.token) ? _c('div', {
    staticClass: "text-center pointer",
    staticStyle: {
      "width": "150px"
    },
    on: {
      "click": _vm.tologin
    }
  }, [_vm._v("\n                登录/注册\n            ")]) : _vm._e(), _vm._v(" "), (_vm.token && _vm.info) ? _c('div', {
    staticClass: "flex justify-center align-center",
    staticStyle: {
      "margin-left": "10px",
      "width": "300px"
    }
  }, [_c('div', {
    staticClass: "headerbox_right_tu"
  }, [_c('img', {
    staticStyle: {
      "border-radius": "50%",
      "width": "100%",
      "height": "100%"
    },
    attrs: {
      "src": _vm._f("addurl")(_vm.info.avatar)
    }
  })]), _vm._v(" "), _c('el-popconfirm', {
    attrs: {
      "title": "确定退出？"
    },
    on: {
      "confirm": _vm.signout
    }
  }, [_c('el-button', {
    staticClass: "text-cut",
    staticStyle: {
      "border": "none",
      "color": "#5778f5",
      "background": "rgba(255, 255, 255, 0)",
      "width": "150px"
    },
    attrs: {
      "slot": "reference"
    },
    slot: "reference"
  }, [_vm._v("\n                        欢迎您，" + _vm._s(_vm.info.username ? _vm.info.username : _vm.info.nickname) + "\n                    ")])], 1), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "color": "#5778f5"
    },
    attrs: {
      "plain": ""
    },
    on: {
      "click": _vm.topersonal
    }
  }, [_vm._v("个人中心")])], 1) : _vm._e()]), _vm._v(" "), (_vm.toptype == 1) ? _c('div', {
    staticClass: "response navall",
    staticStyle: {
      "background": "rgba(255, 255, 255, 0)",
      "position": "absolute",
      "top": "105px",
      "z-index": "99"
    }
  }, [_c('div', {
    staticClass: "\n                    flex\n                    justify-between\n                    align-center\n                    marginauto\n                    text-white\n                    navcon\n                "
  }, [_vm._l((_vm.toplist), function(item, index) {
    return [_c('div', {
      staticClass: "toponenew text-center pointer",
      class: {
        activenew: _vm.toptype == item.type
      },
      on: {
        "click": function($event) {
          return _vm.changenav(item.type, item.path)
        }
      }
    }, [_vm._v("\n                        " + _vm._s(item.title) + "\n                    ")])]
  })], 2)]) : _c('div', {
    staticClass: "response navall"
  }, [_c('div', {
    staticClass: "\n                    flex\n                    justify-between\n                    align-center\n                    marginauto\n                    text-white\n                    navcon\n                "
  }, [_vm._l((_vm.toplist), function(item, index) {
    return [_c('div', {
      staticClass: "topone text-center pointer",
      class: {
        active: _vm.toptype == item.type
      },
      on: {
        "click": function($event) {
          return _vm.changenav(item.type, item.path)
        }
      }
    }, [_vm._v("\n                        " + _vm._s(item.title) + "\n                    ")])]
  })], 2)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4b4e8318"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/topnav.vue
// module id = 397
// module chunks = 1